import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';

const Input = ({ label, getValue, type, value, width, error = false, helperText = "", inputRef }) => {
  return (
    <Box
      sx={{
        '& .MuiTextField-root': { m: 0, width: "100%" },
        ...(error && {
          '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
            borderColor: '#d32f2f',
            borderWidth: '2px',
          },
          '& .MuiOutlinedInput-root.Mui-error.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#d32f2f',
            boxShadow: '0 0 0 3px rgba(211, 47, 47, 0.18)',
          },
        }),
      }}
      noValidate
      autoComplete="off"
    >
      <div>
        <TextField
          className="custom-textfield"
          id="outlined-number"
          label={label}
          type={type || "number"}
          inputRef={inputRef}
          InputLabelProps={{
            shrink: true,
          }}
          onChange={(event) => getValue(event.target.value)}
          value={value}
          error={Boolean(error)}
          helperText={helperText}
          autoComplete="off"
          sx={{
            '& .MuiFormHelperText-root.Mui-error': {
              fontWeight: 500,
              fontSize: '0.78rem',
              marginLeft: '4px',
            },
          }}
          inputProps={{
            autoComplete: 'off',
            form: {
              autoComplete: 'off'
            }
          }}
        />
      </div>
    </Box>
  );
};

export default Input;
